
export default {
  name: 'BlogPostPage',
  async asyncData({ app, $prismic, params, error }) {
    const blogPost = await $prismic.api.getByUID('blog_post', params.slug, {
      lang: app.i18n.localeProperties.prismic,
    })

    if (blogPost) {
      return { blogPost }
    } else {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  data() {
    return {
      showDemoFooter: false,
    }
  },
  head() {
    if (this.blogPost.data) {
      return {
        title:
          (this.blogPost.data.meta_titel ||
            this.$prismic.asText(this.blogPost.data.titel)) + ' | ATHLYZER',
        meta: [
          {
            hid: 'og-title',
            property: 'og:title',
            content:
              (this.blogPost.data.meta_titel ||
                this.$prismic.asText(this.blogPost.data.titel)) + ' | ATHLYZER',
          },
          {
            hid: 'description',
            name: 'description',
            content:
              this.blogPost.data.meta_description ||
              this.$prismic.asText(this.blogPost.data.preview_description),
          },
          {
            hid: 'og-desc',
            property: 'og:description',
            content:
              this.blogPost.data.meta_description ||
              this.$prismic.asText(this.blogPost.data.preview_description),
          },
          {
            hid: 'og-image',
            property: 'og:image',
            content:
              this.blogPost.data.meta_open_graph_image.url ||
              '/ATHLYZER_OG.jpg',
          },
        ],
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 100) {
        this.showDemoFooter = true
      } else {
        this.showDemoFooter = false
      }
    },
    trackDemoBookingEventAndConversion() {
      this.$gtag.event('demo_booking', {
        event_label:
          'Blog Demo - ' + this.$prismic.asText(this.blogPost.data.titel),
      })

      this.$gtag.event('conversion', {
        send_to: 'AW-10985098189/ZFfDCKKYspQYEM2XjfYo',
      })
    },
  },
}
